import "@babel/polyfill";
import 'core-js';
import 'raf/polyfill';

import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import AppRouter from './base/AppRouter';
import { initAnalytics } from './lib/analytics';
import * as serviceWorker from './serviceWorker';

initAnalytics();

ReactDOM.render(<AppRouter />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
